import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	payBy: null,
	error: "",
	loading: false,
};

// ADD_payBy
export const addPayBy = createAsyncThunk(
	"payBy/addPayBy",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `payBy`,
				data: {
					...values,
				},
			});
			toast.success("Pay added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Pay try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_payBy
export const deletePayBy = createAsyncThunk(
	"payBy/deletePayBy ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `payBy/${id}`,
			});

			toast.success("Pay deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting payBy try again");
			console.log(error.message);
		}
	}
);


// payBy
export const getAllPayBy = createAsyncThunk(
	"payBy/getAllPayBy",
	async () => {
		try {
			const { data } = await axios.get(`payBy`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updatePayBy = createAsyncThunk(
	"payBy/updatePayBy",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `payBy/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Pay updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Pay try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const payBySlice = createSlice({
	name: "payBy",
	initialState,
	reducers: {
		clearPayBy: (state) => {
			state.payBy = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllPayBy ======

		builder.addCase(getAllPayBy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllPayBy.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllPayBy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addPayBy  ======

		builder.addCase(addPayBy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addPayBy.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addPayBy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for updatePayBy ======

		builder.addCase(updatePayBy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updatePayBy.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updatePayBy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deletePayBy  ======

		builder.addCase(deletePayBy.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deletePayBy.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deletePayBy.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default payBySlice.reducer;
export const { clearPayBy } = payBySlice.actions;
